import React from "react";
import { Flex, Button, Heading } from "@chakra-ui/react";
import { useAuth } from "../utils/auth-context";
// import { GiHamburgerMenu } from "react-icons/gi";
// import { NavBar } from "../pages/NavBar";
import { RouteComponentProps } from "react-router-dom";

import { useGetPermission } from "../utils/permissions";
interface HeaderProps extends RouteComponentProps {}

export const Header = (props: HeaderProps) => {
  const { logout, data: user } = useAuth();
  const { permissionData, isLoading } = useGetPermission(user?.permission_id);

  // const [navDisplay, setNavDisplay] = useState("none");
  return (
    <Flex
      bg="white"
      justifyContent={"space-between"}
      p={["2", "4", "6"]}
      height="80px"
      flexGrow={1}
    >
      {/* <Flex display={["flex", "flex", "none", "none"]}>
        <IconButton
          position={"absolute"}
          variant="ghost"
          aria-label="Open-Menu"
          size={"lg"}
          icon={<GiHamburgerMenu />}
          ml={"2"}
          onClick={() => setNavDisplay("Flex")}
          borderColor={"#0063cc"}
          color="grey.700"
        />

        <Flex
          zIndex={"5"}
          position="fixed"
          top={"0"}
          left={"0"}
          height="100vh"
          flexDir={"column"}
          display={navDisplay}
        >
          <button
            style={{
              position: "fixed",
              width: "100vw",
              height: "100vh",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              cursor: "default",
              backgroundColor: "#00000057"
            }}
            onClick={() => setNavDisplay("none")}
          ></button>
          <Flex height="100vh" zIndex={1}>
            <CloseButton
              aria-label="Close-Menu"
              right={0}
              size={"md"}
              onClick={() => setNavDisplay("none")}
              position={"absolute"}
            />
            <NavBar {...props}></NavBar>
          </Flex>
        </Flex>
      </Flex> */}
      <Flex
        fontWeight="700"
        marginInlineStart={
          user?.role === "reviewer" && user?.permission_id === null
            ? "87px"
            : "0px"
        }
        color="#05103D"
      >
        <Heading
          fontSize={{ base: "18px", sm: "20px", md: "24px", lg: "24px" }}
        >
          {/* {user?.permission_id !== null
            ? permissionData?.mat?.title
            : permissionData !== undefined &&
              permissionData?.permission_institute?.length > 0
            ? permissionData?.mat?.title
            : user?.instituteTitle} */}
          {user?.permission_id === null
            ? user?.instituteTitle
            : isLoading
            ? ""
            : user?.permission_id !== null &&
              permissionData?.permission_institute?.length > 1
            ? permissionData?.mat?.title
            : user?.instituteTitle}
        </Heading>
      </Flex>
      <Button
        color="red.100"
        rounded="3"
        variant="unstyled"
        _focus={{ border: "none" }}
        fontSize="md"
        onClick={
          // () => {
          // dispatch({ type: "clearAll" });
          logout
          // }
        }
        mr={"5%"}
      >
        Logout
      </Button>
    </Flex>
  );
};
